/* eslint-disable consistent-return */
import { UNAUTHORIZED, RATE_LIMIT_EXCEEDED } from 'actionTypes/user';
import { is } from 'helpers/ramda';
import { addLogsToSentry } from 'helpers/sentry';

export default function promise(request) {
  return ({ dispatch, getState }) =>
    next =>
    action => {
      if (action === undefined) {
        return;
      }

      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      const {
        promise: promiseFunc,
        fetch_main_acc_token: fetchMainAccToken,
        custom_auth_token: customAuthToken,
        types,
        shouldSkipAuthHeader = false,
        ...rest
      } = action;
      if (!promiseFunc) {
        return next(action);
      }

      let REQUEST;
      let SUCCESS;
      let FAILURE;

      if (Array.isArray(types)) {
        [REQUEST, SUCCESS, FAILURE] = types;
      } else if (is(Object, types)) {
        ({ LOAD: REQUEST, SUCCESS, FAIL: FAILURE } = types);
      }

      if (REQUEST) {
        next({ ...rest, type: REQUEST });
      }
      const { user } = getState();
      const { token, main_account: mainAccount } = user;
      if (shouldSkipAuthHeader) {
        request.unsetHeader();
      } else if (fetchMainAccToken && mainAccount) {
        // We have a feature called sub accounts. User can switch to any of the sub account. But sometimes, the data should always be fetched from the main account.
        request.setHeader('Authorization', `${mainAccount.token}`);
      } else if (customAuthToken) {
        request.setHeader('Authorization', `${customAuthToken}`);
      } else if (token) {
        request.setHeader('Authorization', `${token}`);
      } else {
        request.unsetHeader();
      }

      const actionPromise = promiseFunc({ request }, dispatch, getState);
      return actionPromise.then(
        result => {
          // Skip dispatching SUCCESS action if the request was aborted
          if (result && result.aborted) {
            // Added for degraded expereince where we need to
            // decrement the api calls to turn of the loader
            // so based on trackAbortFailure is true
            if (rest?.meta?.trackAbortFailure && FAILURE) {
              next({ ...rest, type: `${FAILURE}_ABORTED`, aborted: true });
            }

            return result;
          }
          if (SUCCESS) {
            next({ ...rest, result, type: SUCCESS });
          }
          if (action?.promiseResolveCallback) {
            action.promiseResolveCallback(result);
          }
          return result;
        },
        error => {
          const errorAction = { ...rest, error };
          switch (error.status) {
            case 401:
              errorAction.type = UNAUTHORIZED;
              break;
            case 429:
              errorAction.type = RATE_LIMIT_EXCEEDED;
              break;
            default:
              errorAction.type = FAILURE;
              break;
          }
          if (errorAction.type) {
            next(errorAction);
          }
          if (action?.promiseResolveCallback) {
            action.promiseResolveCallback(null, error);
          }
          if (error.status !== 429) {
            addLogsToSentry(user, error);
          }
          return Promise.reject(error);
        }
      );
    };
}
